/**
 * The show / hide password glyph from the sign-in design (temp/login.html): an open eye while the
 * password is hidden, a struck-through one while it is shown.
 *
 * @param {object} props
 * @param {boolean} props.shown - whether the password is currently visible
 * @returns {JSX.Element}
 */
function PosPasswordPeekIcon({ shown }) {
  const common = {
    viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2,
    strokeLinecap: 'round', strokeLinejoin: 'round', 'aria-hidden': true,
  };
  if (shown) {
    return (
      <svg {...common}>
        <path d="M10.6 6.2A9.9 9.9 0 0 1 12 5c6.4 0 10 7 10 7a18 18 0 0 1-3.1 4M6.2 6.7A18 18 0 0 0 2 12s3.6 7 10 7a9.7 9.7 0 0 0 4.7-1.2" />
        <path d="M3 3l18 18" />
        <path d="M9.9 9.9a3 3 0 0 0 4.2 4.2" />
      </svg>
    );
  }
  return (
    <svg {...common}>
      <path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7-10-7-10-7z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );
}

export default PosPasswordPeekIcon;
